import { render, staticRenderFns } from "./Prospect.vue?vue&type=template&id=2d88d9fb&"
import script from "./Prospect.vue?vue&type=script&lang=js&"
export * from "./Prospect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports